<template>
    <div :class="classes" @click.self="showPanel">
        <a class="ContextPanel__toggler" @click.prevent="toggle"></a>
        <div class="ContextPanel__heading" v-show="showHeading" @click="toggle">{{ heading }}</div>
        <div class="ContextPanel__body" v-show="show">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                show: true,
                windowWidth: '',
            }
        },

        props: {
            heading: {
                type: String,
                default: ''
            },

            isPublic: {
                type: Boolean,
                default: false
            }
        },

        mounted() {
            if (document.documentElement.clientWidth <= 991) {
                this.closePanel();
            }

            bus.$on('close-context-panel', () => {
                this.closePanel();
            })

            bus.$on('toggle-context-panel', () => {
                this.toggle();
            });

            bus.$on('context-panel-check-scroll', () => {
                this.checkIfScrolling();
            });

            this.handleResize();

            window.addEventListener('resize', this.handleResize);
        },

        computed: {
            classes() {
                return  {
                    'ContextPanel': true,
                    'ContextPanel--closed': ! this.show,
                    'ContextPanel--open': this.show,
                    'ContextPanel--public': this.isPublic
                }
            },

            showHeading() {
                if (this.windowWidth <= 991) {
                    return true;
                }

                return this.show;
            }
        },

        methods: {
            /**
             * Toggle whether the context panel is open
             */
            toggle() {
                this.show = !this.show;

                if (this.show) {
                    document.querySelector('.Content').classList.add('Content--context-panel-open');

                    if (this.isPublic) {
                        document.querySelector('body').classList.add('Utility--no-scroll-public');
                    }
                } else {
                    document.querySelector('.Content').classList.remove('Content--context-panel-open');

                    if (this.isPublic) {
                        document.querySelector('body').classList.remove('Utility--no-scroll-public');
                    }
                }
            },

            closePanel() {
                this.show = false;
                document.querySelector('.Content').classList.remove('Content--context-panel-open');

                if (this.isPublic) {
                    document.querySelector('body').classList.remove('Utility--no-scroll-public');
                }
            },

            showPanel() {
                if (this.show) return;

                this.toggle();
            },

            handleResize() {
                this.windowWidth = document.documentElement.clientWidth;

                this.checkIfScrolling();
            },

            checkIfScrolling() {
                let bodyScrollHeight = document.querySelector('.ContextPanel__body').scrollHeight;
                let bodyHeight = document.querySelector('.ContextPanel__body').clientHeight;

                if (bodyScrollHeight > bodyHeight) {
                    document.querySelector('.FilterControls').classList.add('FilterControls--sticky');
                } else {
                    document.querySelector('.FilterControls').classList.remove('FilterControls--sticky');
                }
            }
        }
    }
</script>